var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeparateChecksSolid = function SvgSeparateChecksSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.143 2.25A1.893 1.893 0 0 0 2.25 4.143v9.143a.75.75 0 0 0 1.156.63L5 12.893l1.594 1.025a.75.75 0 0 0 .812 0L9 12.892l1.594 1.025a.75.75 0 0 0 1.156-.631V4.143A1.893 1.893 0 0 0 9.857 2.25H4.143ZM5.25 6A.75.75 0 0 1 6 5.25h2a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6Zm0 3A.75.75 0 0 1 6 8.25h2a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 9ZM14.143 9.964a1.893 1.893 0 0 0-1.893 1.893V21a.75.75 0 0 0 1.156.63L15 20.607l1.594 1.025a.75.75 0 0 0 .812 0L19 20.606l1.594 1.025A.75.75 0 0 0 21.75 21v-9.143a1.893 1.893 0 0 0-1.893-1.893h-5.714Zm1.107 3.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Zm0 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgSeparateChecksSolid;